"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AvatarStack = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var classnames_1 = __importDefault(require("classnames"));
var theme_1 = __importDefault(require("../../../styles/theme"));
var Typography_1 = require("../../atoms/Typography/Typography");
var UserAvatar_1 = require("../../atoms/UserAvatar/UserAvatar");
var AvatarStack_logic_1 = require("./AvatarStack.logic");
var AvatarStack_style_1 = __importDefault(require("./AvatarStack.style"));
/**
 * AvatarStack molecule
 *
 * {@link https://stories.data.bmw.cloud/?path=/docs/molecules-avatarstack--bound-story Docs}
 * {@link https://github.com/bmw-cdh/cdh-data-portal-theme/tree/main/components/molecules/AvatarStack Source}
 */
var AvatarStack = function (_a) {
    var maxItems = _a.maxItems, _b = _a.itemOffset, itemOffset = _b === void 0 ? -12 : _b, onClick = _a.onClick, className = _a.className, users = _a.users, avatars = _a.avatars, total = _a.total;
    var classes = (0, AvatarStack_style_1.default)({ itemOffset: itemOffset });
    var _c = (0, AvatarStack_logic_1.useAvatarStack)({ users: users, avatars: avatars, maxItems: maxItems, total: total }), items = _c.items, formattedNumberOfItems = _c.formattedNumberOfItems, showPlus = _c.showPlus;
    return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: (0, classnames_1.default)(classes.root, !!onClick && classes.clickable, className), onClick: onClick }, { children: [items.map(function (item, index) {
                return ((0, jsx_runtime_1.jsx)("div", __assign({ className: classes.itemWrapper, style: { zIndex: items.length + 1 - index } }, { children: renderAvatarItem(item) }), index));
            }), showPlus && ((0, jsx_runtime_1.jsx)("div", __assign({ className: classes.plusWrapper }, { children: (0, jsx_runtime_1.jsx)(Typography_1.Typography, __assign({ variant: 'label1', bold: true, color: theme_1.default.textColors.highlight }, { children: "+".concat(formattedNumberOfItems) })) })))] })));
    function renderAvatarItem(item) {
        if (typeof item === 'object' && 'initials' in item) {
            return (0, jsx_runtime_1.jsx)(UserAvatar_1.UserAvatar, { user: item, size: 'compact' });
        }
        return item;
    }
};
exports.AvatarStack = AvatarStack;
